<substitute-admin-new (editClick)="onNewEditClick($event)"></substitute-admin-new>
<substitute-admin-grid
  [gridData]="substitute$ | async" (deleteSubstitution)="onDelete($event)"
  (editSubstitution)="onEdit($event)"></substitute-admin-grid>
